import { BIModel } from './BIModel';

export class BuySizePersonalizeBIModel extends BIModel {
  static eventName = 'buy_size_personalize';

  #flow;
  #action;

  constructor(userId, flow, action) {
    super(BuySizePersonalizeBIModel.eventName, userId);
    this.#flow = flow;
    this.#action = action;
  }

  get flow() {
    return this.#flow;
  }

  get action() {
    return this.#action;
  }

  get modelData() {
    return {
      flow: this.flow,
      action: this.action
    };
  }

}